import { AfterViewInit, Component, inject } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { UserGroups } from '../../shared/models/user.model';
import { UserGroupService } from '../../shared/service/user-group.service';

@Component({
    selector: 'app-admin',
    imports: [RouterOutlet],
    templateUrl: './admin.component.html'
})
export class AdminComponent implements AfterViewInit {
  private router = inject(Router);
  private userGroupService = inject(UserGroupService);


  ngAfterViewInit(): void {
    setTimeout(() => {
      this.navigateToAppropriateRoute();
    });
  }

  private navigateToAppropriateRoute(): void {
    const currentUrl = this.router.url;

    // Check it is the landing route from cognito
    if (currentUrl === '/admin') {
      this.redirectBasedOnUserGroups();
    } else {
      // for page refresh, navigate to the current route
      this.router.navigate([currentUrl]);
    }
  }

  private redirectBasedOnUserGroups(): void {
    if (this.hasGroupAccess([UserGroups.OWNER, UserGroups.CLIENT_ADMIN, UserGroups.SUPER_ADMIN, UserGroups.DEVELOPER])) {
      this.router.navigate(['/admin/users'], { replaceUrl: true });
    } else if (this.hasGroupAccess([UserGroups.PRODUCT_ADMIN])) {
      this.router.navigate(['/admin/products'], { replaceUrl: true });
    } else {
      this.router.navigate(['/admin/access-denied'], { replaceUrl: true });
    }
  }

  private hasGroupAccess(groups: UserGroups[]): boolean {
    const userGroups = this.userGroupService.getUserGroups();
    return groups.some((group) => userGroups.includes(group));
  }
}
